import { Form } from "components/Form/base/Form";
import FormConsumser from "components/Form/base/FormConsumer";
import { SubmitInput } from "components/Form/SubmitInput";
import { TextInput } from "components/Form/TextInput";
import FormFields from "../../Formular/FormFields";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import { Moment } from "moment";
import { useState } from "react";
import useSWR from "swr";
import { BookingForm } from ".";
import { RepeatKey, Space, SpaceBooking, SpaceGroup, SpaceSubscription } from "../types";
import { useDebouncedValue } from "../../../hooks/useDebouncedValue";

interface Props {
    clubSlug: string;
    startTime?: number;
    startDate?: Moment;
    callback?: (newBooking: SpaceBooking) => void;
}

export const ManualSpaceBookingForm = ({
                                           clubSlug, startDate, startTime, callback = () => {
    }
                                       }: Props) => {
    const api = useApi();
    const { data } = useSWR<{ data: SpaceGroup[] }>(clubSlug ? `space/group/${clubSlug}` : null);
    const { data: subscriptionsData } = useSWR(`space/subscription/${clubSlug}`);
    const [currentSpaceGroup, setCurrentSpaceGroup] = useState<SpaceGroup>();
    const [currentSubscription, setCurrentSubscription] = useState<SpaceSubscription>();
    const { data: formData } = useSWR(currentSpaceGroup?.form_id ? `form/${currentSpaceGroup.form_id}` : null);
    const fields = formData?.data?.fields;
    const [isLoading, setIsLoading] = useState(false);
    const [bookingData, setBookingData] = useState<{
        start: string;
        start_time: number;
        end_time: number;
        repeat_until: string;
        repeat_period: RepeatKey;
        spaces: string;
        calculatedPrice: number;
    }>();

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: "space/booking/manual",
            method: "POST",
            data: {
                ...data,
                subscription_id: currentSubscription?.id,
                booking: {
                    ...bookingData,
                    spaces: (bookingData.spaces as unknown as Space[]).map((space: Space) => space.id)
                }
            },
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback(data)
        });
    };

    const schema = Joi.object({
        name: Joi.string().required().max(255).label("Name"),
        email: Joi.string()
            .email({ tlds: { allow: false } })
            .required()
            .label("E-Mail Adresse")
    }).unknown();

    if (!bookingData)
        return (
            <>
                <div className="form-group">
                    <label>Platzgruppe</label>
                    <select
                        className="form-control mb-2"
                        value={currentSpaceGroup?.id}
                        onChange={(e) => {
                            setCurrentSpaceGroup(data?.data.find((g) => g.id === Number(e.target.value)));
                        }}
                    >
                        <option>Bitte wählen ...</option>
                        {data?.data.map((group) => (
                            <option key={group.id} value={group.id}>
                                {group.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Zugeordnetes Abo (optional)</label>
                    <select
                        className="form-control mb-2"
                        value={currentSubscription?.id}
                        onChange={(e) => setCurrentSubscription(subscriptionsData?.data.find((s) => s.id === Number(e.target.value)))}
                    >
                        <option>Bitte wählen ...</option>
                        {subscriptionsData?.data.map((subscription) => (
                            <option key={subscription.id} value={subscription.id}>
                                {subscription.title}
                            </option>
                        ))}
                    </select>
                </div>
                {currentSpaceGroup && (
                    <BookingForm
                        key={currentSubscription?.id}
                        adminMode
                        spaceGroup={currentSpaceGroup}
                        startDate={startDate}
                        startTime={startTime}
                        callback={(booking) => setBookingData(booking)}
                        subscription={currentSubscription}
                    />
                )}
            </>
        );

    return (
        <Form onSubmit={handleSubmit} validationSchema={schema}>
            <TextInput name="name" label="Name *" />
            <TextInput name="email" label="E-Mail Adresse *" />
            <FormConsumser>
                {({ watch, setValue }) => {
                    const email = watch("email");
                    const debouncedUserEmail = useDebouncedValue(email, 800);
                    const { data: clubMemberData } = useSWR(
                        [`space/group/${currentSpaceGroup.id}/members`, { search: debouncedUserEmail }]
                    );

                    return (
                        <>
                            {email && <div className="tw-flex tw-flex-col tw-gap-2"
                            >{clubMemberData?.data?.slice(0, 5).map((fellow) => (
                                <div className="tw-flex tw-gap-2 tw-items-center tw-card-flat tw-card-clickable tw-p-2"
                                    key={`${fellow.name}-${fellow.email}`}
                                    onClick={() => {
                                        setValue("name", fellow.name);
                                        setValue("email", fellow.email);
                                    }}
                                >
                                    <span className="tw-text-md tw-font-semibold">{fellow.name}</span>
                                    <span className="tw-text-xs tw-italic tw-text-accents-6">{fellow.email}</span>
                                </div>
                            ))}
                            </div>}
                            {/*<VoucherCardAssistent email={email}*/}
                            {/*    usedUnits={bookingData.end_time - bookingData.start_time}*/}
                            {/*/>*/}
                        </>
                    );
                }}
            </FormConsumser>
            <SubmitInput className="my-3" block isLoading={isLoading}>
                Buchung OHNE Formular Daten speichern
            </SubmitInput>
            {fields && <FormFields fields={fields} namePrefix="form_data" />}
            <SubmitInput block isLoading={isLoading}>
                Speichern
            </SubmitInput>
        </Form>
    );
};
